var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAr1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 102,
    viewBox: "0 0 272 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.01465,
    width: 271,
    height: 100,
    rx: 4.5,
    fill: "",
    stroke: "#64748b85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.835 53.4713L128.731 47.7198C128.627 47.4647 128.52 47.1618 128.408 46.8111C128.297 46.4603 128.185 46.0817 128.073 45.6751C127.97 46.0817 127.862 46.4643 127.75 46.823C127.639 47.1738 127.531 47.4807 127.428 47.7437L125.335 53.4713H130.835ZM136.515 60H134.028C133.749 60 133.522 59.9322 133.347 59.7967C133.171 59.6532 133.04 59.4779 132.952 59.2706L131.661 55.7432H124.498L123.207 59.2706C123.143 59.4539 123.019 59.6214 122.836 59.7728C122.653 59.9243 122.425 60 122.154 60H119.643L126.447 42.7097H129.723L136.515 60ZM144.009 50.9364C144.614 50.9364 145.14 50.8606 145.587 50.7092C146.041 50.5577 146.412 50.3504 146.699 50.0874C146.994 49.8164 147.213 49.4975 147.357 49.1308C147.5 48.7641 147.572 48.3615 147.572 47.9231C147.572 47.0462 147.281 46.3726 146.699 45.9023C146.125 45.432 145.244 45.1968 144.056 45.1968H142V50.9364H144.009ZM152.283 60H149.377C148.827 60 148.429 59.7848 148.182 59.3543L144.547 53.8181C144.411 53.6108 144.26 53.4633 144.092 53.3756C143.933 53.288 143.694 53.2441 143.375 53.2441H142V60H138.783V42.7097H144.056C145.228 42.7097 146.233 42.8333 147.07 43.0804C147.915 43.3195 148.604 43.6583 149.138 44.0968C149.68 44.5352 150.079 45.0613 150.334 45.6751C150.589 46.281 150.717 46.9506 150.717 47.684C150.717 48.2659 150.629 48.8159 150.454 49.3341C150.286 49.8522 150.039 50.3225 149.712 50.745C149.393 51.1675 148.995 51.5382 148.516 51.8571C148.046 52.1759 147.508 52.427 146.902 52.6104C147.109 52.73 147.301 52.8734 147.476 53.0408C147.652 53.2003 147.811 53.3916 147.954 53.6148L152.283 60Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr1);
export default __webpack_public_path__ + "static/media/AR1.8b80562f6f565ed0ec19baf7086c491f.svg";
export { ForwardRef as ReactComponent };